import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { hideModal } from '../../../../services/modal/actions';

import { formatAmountCurrency } from '../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import ButtonComponent from '../../../button/ButtonComponent';

import './PaymentRequestEbonUnavailableModal.scss';

class PaymentRequestEbonUnavailableModal extends React.Component {
    handleHideModal = () => {
        this.props.hideModal();
    };

    render() {
        const { i18n, data, partner } = this.props;

        return (
            <div className="payment-request-ebon-unavailable-modal">
                <div className="header">
                    <p>{i18n.TITLE}</p>
                </div>
                <div className="content">
                    <p>{i18n.TEXT_1}</p>
                    {data.map((ebons, id) => (
                        <div key={id} className="recapUnavailable">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    i18n.EBON,
                                    partner.name,
                                    formatAmountCurrency(ebons.facialValue)
                                )}
                            </p>
                            <div className="availability">
                                <span>
                                    {ebons.quantityLocked}/{ebons.quantityQuery}{' '}
                                </span>
                                <span>{i18n.TEXT_2}</span>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="buttons">
                    <ButtonComponent
                        text={i18n.BUTTON}
                        color="main"
                        onClick={this.handleHideModal}
                    />
                </div>
            </div>
        );
    }
}

PaymentRequestEbonUnavailableModal.propTypes = {
    data: PropTypes.object,
    partner: PropTypes.object
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT.MODAL_EBON_UNAVAILABLE
    };
};

const mapDispatchToProps = {
    hideModal
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRequestEbonUnavailableModal);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentRequestEbonUnavailableModal.js